import { Auth } from "aws-amplify";

// Import state
import { setRecoil } from "recoil-nexus";
import { accessTokenState } from "../../state/atoms/accessToken";
import { userState } from "../../state/atoms/user";
import { loggedInState } from "../../state/atoms/loggedIn";

export const refreshUser = async (): Promise<string | null> => {
    try {
        // First, try to get the current session
        const userSession = await Auth.currentSession();
        const accessToken = userSession.getAccessToken().getJwtToken();
        
        // Check if token is expired or about to expire (within 5 minutes)
        const tokenExp = userSession.getAccessToken().getExpiration() * 1000; // Convert to milliseconds
        const now = Date.now();
        const fiveMinutes = 5 * 60 * 1000;
        
        if (tokenExp - now < fiveMinutes) {
            // Token is expired or about to expire, try to refresh
            console.log("Token expired or about to expire, attempting refresh...");
            await Auth.currentAuthenticatedUser(); // This triggers a token refresh
            const newSession = await Auth.currentSession();
            const newAccessToken = newSession.getAccessToken().getJwtToken();
            setRecoil(accessTokenState, newAccessToken);
            return newAccessToken;
        }
        
        // Token is still valid
        setRecoil(accessTokenState, accessToken);
        return accessToken;
    } catch (err: any) {
        console.log("Token refresh failed:", err);
        
        // Check if it's a token revocation error
        if (err.code === "NotAuthorizedException" || 
            err.message?.includes("Access Token has been revoked") ||
            err.message?.includes("Token has been revoked")) {
            
            console.log("Token has been revoked, logging out user");
            
            // Clear user state and redirect to login
            setRecoil(userState, null);
            setRecoil(loggedInState, false);
            setRecoil(accessTokenState, "");
            
            // Redirect to home page or login
            window.location.href = "/";
            return null;
        }
        
        // For other errors, just return null
        return null;
    }
};
